<script>
  import PagesTemplate from "./PagesTemplate.svelte";
  import projects from "../constants/projects";
  import { hexToRgb } from "../helpers/utilities";
  import WorkImage from "./WorkImage.svelte";

  let maskColor1 = hexToRgb("#032539");

  const hasAPI = "IntersectionObserver" in window;
</script>

<style>

</style>

<PagesTemplate title="Work" subtitle="">
  <p class="subnav" slot="subnav">
    <a
      href="https://docs.google.com/presentation/d/1Kv0Wq-1vPAJJDJhf0V4xjc_UtyG7yxJUWwImwz1O7ig/edit?usp=sharing"
      target="_blank">
      A deck of some work samples can be found here.
    </a>
  </p>

  {#each projects as project, i}
    <WorkImage
      url={`/images/projects/${project.name}`}
      alt={project.name}
      title={project.title}
      {project}
      lazy={hasAPI && i} />
  {/each}

</PagesTemplate>
